import { useMemo } from 'react';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { PENDING_SRC } from '../../constants/pendingSrc';
import { DesktopProductMediaGalleryVariantFragment } from '../../generated/types';
import { DesktopProductMediaGalleryThumbType } from './DesktopProductMediaGallery';

type AlternateImage = NonNullable<
  DesktopProductMediaGalleryVariantFragment['alternateImages'][number]
>;

export const useDesktopProductMediaGalleryImageThumbnails = (images: AlternateImage[]) => {
  const optimizationEnabled = useFeatureFlag('optimize-pdp-images-desktop', [
    { default: false },
    { if: true, then: true }
  ]);

  const thumbnails = useMemo(
    () =>
      images.map((image, index) => ({
        key: image.small || `image -- ${index}`,
        src: image.small || PENDING_SRC,
        large: optimizationEnabled ? image.large : image.raw,
        type: DesktopProductMediaGalleryThumbType.Image as const,
        thumb: image.thumb
      })),
    [optimizationEnabled, images]
  );

  return thumbnails;
};
